import {useCallback, useState} from 'react';
import type {Job, QuestionStatus} from '@cp/model';
import {jobCreateBulkChangeQuestionStatus} from '../api/callable/jobs';

export function useCreateBulkChangeQuestionStatusJob() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  /**
   * Create a bulk change question status job
   * @param moduleId - The module ID to change question statuses for
   * @param filterStatus - The current status to filter questions by
   * @param changeStatus - The new status to change questions to
   * @returns The created job document
   */
  const createBulkChangeQuestionStatusJob = useCallback(
    async (moduleId: string, filterStatus: QuestionStatus, changeStatus: QuestionStatus): Promise<Job> => {
      setLoading(true);
      setError(undefined);
      try {
        return await jobCreateBulkChangeQuestionStatus({moduleId, filterStatus, changeStatus});
      } catch (err) {
        const e = err instanceof Error ? err : new Error(String(err));
        setError(e);
        throw e;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return {
    createBulkChangeQuestionStatusJob,
    loading,
    error,
  };
}
